import React, { useEffect, useRef } from 'react';

const SlideVideo = ({ isMobile, desktop, mobile, isFirst }) => {
  if (isMobile) {
    return <Video url={mobile.mp4High} thumbnail={mobile.thumbnailUrl} isFirst={isFirst} />
  }
  return <Video url={desktop.mp4High} thumbnail={desktop.thumbnailUrl} isFirst={isFirst} />
}

const Video = ({ url, thumbnail, isFirst }) => {

  const sourceRef = useRef();
  const videoRef = useRef();
  
  useEffect(() => {
    if(isFirst){
      sourceRef.current.src = sourceRef.current.getAttribute('data-src');
      videoRef.current.play();
    }
  }, []);

  return (
    <video
      ref={videoRef}
      className="lazy"
      width="100%"
      height="100%"
      autoPlay
      loop
      poster={thumbnail}
      muted
      playsInline
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      }}
    >
      {
        isFirst && (<source ref={sourceRef} data-src={url} type="video/mp4" />)
      }
      {
        !isFirst && (<source src={url} type="video/mp4" />)
      }

    </video>
  )
}

export default SlideVideo
